import { IApplicationState } from '../../types/redux';

export const selectCompilations = (state: IApplicationState) => {
  return state.newbuildingRecommendations.compilations.slice(0, 2);
};
